import { Component } from '@angular/core';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  standalone: true,
  selector: 'pm-form-field-time',
  imports: [ReactiveFormsModule, DatePickerModule],
  templateUrl: './pm-form-field-time.component.html',
  styleUrl: './pm-form-field-time.component.scss',
})
export class PmFormFieldTimeComponent extends FormFieldComponent {}
